import { render, staticRenderFns } from "./RarePaneControl.vue?vue&type=template&id=5a10e4a2&scoped=true"
import script from "./RarePaneControl.vue?vue&type=script&lang=js"
export * from "./RarePaneControl.vue?vue&type=script&lang=js"
import style0 from "./RarePaneControl.vue?vue&type=style&index=0&id=5a10e4a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a10e4a2",
  null
  
)

export default component.exports